import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {PlotlyModule, PlotlySharedModule} from "angular-plotly.js";
import {SeriesSummaryChartTileConfiguration} from "../chart-config/generic-chart-tile.configuration";
import {take, takeUntil} from "rxjs/operators";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {DateTimePeriod} from "../../_typing/date-time-period";
import {BaseComponent} from "../../shared/base.component";
import {ProgressTrackerChartService} from "./progress-tracker-chart.service";

@Component({
    selector: 'progress-tracker-chart',
    imports: [
        PlotlyModule
    ],
    templateUrl: './progress-tracker-chart.component.html',
    styleUrl: './progress-tracker-chart.component.scss',
    providers: [ProgressTrackerChartService]
})
export class ProgressTrackerChartComponent extends BaseComponent {

    @Input() config: SeriesSummaryChartTileConfiguration;
    dtp: DateTimePeriod;

    data = [];
    layout: any;
    plotConfig: any;

    @ViewChild('plotlyContainer') plotlyContainer: ElementRef<HTMLDivElement>;

    constructor(private dateInst: DateTimeInstanceService,
                private cps: ProgressTrackerChartService) {
        super();
    }

    ngOnInit() {
        // Columns will be dynamically set based on period type and estimate type in the service
        this.getChart(this.config)
    }

    getChart(config) {
        this.dtp = this.dateInst.dtp;
        this.cps.$chartConfigReady.pipe(takeUntil(this.onDestroy))
            .subscribe(chart_config => {
                this.data = chart_config.data;
                this.layout = chart_config.layout;
                this.plotConfig = chart_config.config;
            })

        if (this.plotlyContainer?.nativeElement.clientHeight) {
            this.config.set_size = {height: this.plotlyContainer.nativeElement.clientHeight}
        }

        this.dateInst.dateTimePeriodRefreshed$.pipe(takeUntil(this.onDestroy))
            .subscribe(dtp => {
                this.cps.getChart(this.config);
            })

        this.dateInst.dateTimePeriodChanged$.pipe(take(1))
            .subscribe(dtp => {
                this.cps.getChart(this.config);
            })
    }

}
